// import { checkIfRowContainsGeneratedCells } from "../../generator/_Buttons/AddCommentsButton/AddCommentsButton.utils";
import {
  getNewRow,
  replaceExclusiveValues,
} from "../../generator/utils/dynamicRows";
import type { IRow, ISection } from "../../interfaces";
/**
 * Generates a new row with exclusive values for a given section and row index.
 *
 * @param section - The section containing the rows.
 * @param rowIndex - The index of the row to process.
 * @param dontClear - (Optional) A flag indicating whether to retain existing values. Defaults to `false`.
 * @returns A new row object with updated exclusive values.
 */
export const getRowWithExclusives = (
  section: ISection,
  rowIndex: number,
  dontClear?: boolean,
): IRow => {
  let newRowWithNewExlusivesIds = null;
  const row = section.rows[rowIndex] as any;
  if (row.subrows) {
    const subrows = row.subrows;
    // LOGIC TO SKIP ADDITIONAL GENERATED SUBROWS (COMMENTS)
    // row.subrows.filter(
    //   (subrow: any) => !checkIfRowContainsGeneratedCells(subrow),
    // );

    newRowWithNewExlusivesIds = {
      subrows: subrows.map((subrow: any) => {
        const cols = subrow.cols;
        return { cols: replaceExclusiveValues(getNewRow(cols, dontClear)) };
      }),
    };
  } else {
    const cols = row.cols;
    newRowWithNewExlusivesIds = {
      cols: replaceExclusiveValues(getNewRow(cols, dontClear)),
    };
  }
  return newRowWithNewExlusivesIds;
};
